module.exports = __webpack_public_path__ + "media/images/products/category/2-a8abdbad71790887f10285f5c317e49e.jpg";